module.exports = __webpack_public_path__ + "img/btn_shitu_di.d4a7785d.png";